var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkOn1X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons/bookmark_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 16,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M22 4C23.1046 4 24 4.89543 24 6V26.1958C24 26.748 23.5523 27.1958 23 27.1958C22.8126 27.1958 22.6289 27.1431 22.47 27.0438L16.53 23.3312C16.2057 23.1286 15.7943 23.1286 15.47 23.3312L9.53 27.0438C9.06166 27.3365 8.44471 27.1941 8.152 26.7258C8.05267 26.5668 8 26.3832 8 26.1958V6C8 4.89543 8.89543 4 10 4H22Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75 Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 32,
    height: 32,
    fill: "#E8703C"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOn1X);
export default __webpack_public_path__ + "static/media/bookmark_on@1x.6671d7bf91fad9b21126ec216af6bc78.svg";
export { ForwardRef as ReactComponent };